import './SignupView.scss'

import React, { useRef, useState } from 'react'

import Button from '../components/Button/Button'
import { Form } from '../components/Form/Form'
import { ReactComponent as RefereePro } from '../icons/general/refereepro.svg'
import TextField from '../components/TextField/TextField'
import { post } from '../helpers/request'
import t from '../helpers/i18n'
import { withRouter } from 'react-router-dom'

const emailValidation = (text) =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(text)
    ? false
    : t('El correo no es válido.')
const phoneValidation = (text) =>
  /^.{1,20}$/.test(text)
    ? false
    : t('El número de teléfono no es válido.')

const SignupView = ({ history }) => {
  const [formValid, setFormValid] = useState(false)
  const [error, setError] = useState()
  const signupData = useRef({})

  const handleSignup = () => {
    setError(false)
    post('/signup', signupData.current)
      .then((response) => {
        history.push('/')
      })
      .catch((error) => {
        if (error.code === 'VALIDATION_ERROR') {
          setError(t('validations.data_were_incorrect'))
        } else if (
          error.data &&
          error.data.message === 'ACCOUNT_ALREADY_EXISTS'
        ) {
          setError(
            t('validations.Account_already_exists')
          )
        } else {
          setError(t('validations.Error interno.'))
        }
      })
  }

  return (
    <div className="signup-view">
      <div className="-logo"><RefereePro /></div>
      <div className="-title heading-tiny-bold">{t('Crear cuenta')}</div>
      <div className="-content">
        <Form data={signupData} onValidityChange={setFormValid}>
          <TextField
            name="firstname"
            label={t('Name')}
            maxLength={100}
            minLength={2}
            required
            />
          <TextField
            name="lastname"
            label={t('Apellidos')}
            maxLength={100}
            />
          <TextField
            name="phone"
            label={t('Teléfono de contacto')}
            onValidation={phoneValidation}
            maxLength={50}
            />
          <TextField
            name="email"
            label={t('labels.Email')}
            onValidation={emailValidation}
            minLength={5}
            maxLength={100}
            required
            />
          <TextField
            name="password"
            label={t('Clave secreta')}
            minLength={6}
            password
            required
            />
        </Form>
        {error && <div className="-error caption-default-basic">{error}</div>}
        <div className="-buttons">
          <Button
            label={t('buttons.Create_account')}
            type="dark"
            color="green"
            grow
            disabled={!formValid}
            onClick={handleSignup}
          />
        </div>
        <div className="-guest">
          <div className="-text caption-small-basic">{t('Ya tienes una cuenta?')}</div>
          <div className="-line" />
        </div>
        <div className="-buttons">
          <Button
            label="Entrar"
            type="light"
            color="neutral"
            grow
            onClick={() => history.push('/login')}
          />
        </div>
      </div>
    </div>
  )
}

export default withRouter(SignupView)
